import { get, del, put, post, upload } from '@api/request';

export async function fetchDeed(
  { appraisalService },
  authenticationToken,
  { deedID },
) {
  const url = `${appraisalService}/appraisal/deed/${deedID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDeedTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Deed&name=Deed%20Type`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyDeeds(
  { appraisalService },
  authenticationToken,
  { propertyId },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/deeds`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMostCurrentDeed(
  { appraisalService },
  authenticationToken,
  { propertyId },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/deeds/current`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deletePropertyDeed(
  { appraisalService },
  authenticationToken,
  { deedID },
) {
  const url = `${appraisalService}/appraisal/deed/${deedID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function reorderPropertyDeeds(
  { appraisalService },
  authenticationToken,
  { propertyId, payload },
) {
  const url = `${appraisalService}/appraisal/property/${propertyId}/deeds/setorder`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function createPropertyDeed(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/deeds`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updatePropertyDeed(
  { appraisalService },
  authenticationToken,
  { deedID, payload },
) {
  const url = `${appraisalService}/appraisal/deed/${deedID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchDeedProperties(
  { appraisalService },
  authenticationToken,
  { deedID },
) {
  const url = `${appraisalService}/appraisal/deed/${deedID}/property`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createDeedProperty(
  { appraisalService },
  authenticationToken,
  { deedID, payload },
) {
  const url = `${appraisalService}/appraisal/deed/${deedID}/property`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchDeedProperty(
  { appraisalService },
  authenticationToken,
  { deedPropertyID },
) {
  const url = `${appraisalService}appraisal/deed/property/${deedPropertyID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteDeedProperty(
  { appraisalService },
  authenticationToken,
  { deedPropertyID },
) {
  const url = `${appraisalService}/appraisal/deed/property/${deedPropertyID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export const fetchFiles = async (
  { appraisalService },
  authenticationToken,
  { deedID },
) => {
  const url = `${appraisalService}/appraisal/deed/${deedID}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createFile = async (
  { appraisalService },
  authenticationToken,
  { deedID, payload },
) => {
  const url = `${appraisalService}/appraisal/deed/${deedID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export async function updateFile(
  { appraisalService },
  authenticationToken,
  { deedID, payload },
) {
  const url = `${appraisalService}/appraisal/deed/${deedID}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const deleteFile = async (
  { appraisalService },
  authenticationToken,
  { deedID, s3ID, payload },
) => {
  const url = `${appraisalService}/appraisal/deed/${deedID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const getFile = async (
  { appraisalService },
  authenticationToken,
  { deedID, s3ID },
) => {
  const url = `${appraisalService}/appraisal/deed/${deedID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function fetchDeedSellers(
  { appraisalService },
  authenticationToken,
  { deedID },
) {
  const url = `${appraisalService}/appraisal/deed/${deedID}/allsellers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDeedBuyers(
  { appraisalService },
  authenticationToken,
  { deedID },
) {
  const url = `${appraisalService}/appraisal/deed/${deedID}/allbuyers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createDeedSeller(
  { appraisalService },
  authenticationToken,
  { deedPropertyID, payload },
) {
  const url = `${appraisalService}/appraisal/deed/property/${deedPropertyID}/sellers`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export const deleteDeedSeller = async (
  { appraisalService },
  authenticationToken,
  { deedPropertySellerID },
) => {
  const url = `${appraisalService}/appraisal/deed/property/seller/${deedPropertySellerID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export async function updateDeedSeller(
  { appraisalService },
  authenticationToken,
  { deedPropertySellerID, payload },
) {
  const url = `${appraisalService}/appraisal/deed/property/seller/${deedPropertySellerID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function createDeedBuyer(
  { appraisalService },
  authenticationToken,
  { deedPropertyID, payload },
) {
  const url = `${appraisalService}/appraisal/deed/property/${deedPropertyID}/buyers`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export const deleteDeedBuyer = async (
  { appraisalService },
  authenticationToken,
  { deedBuyerID },
) => {
  const url = `${appraisalService}/appraisal/deed/property/buyer/${deedBuyerID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export async function updateDeedBuyer(
  { appraisalService },
  authenticationToken,
  { deedBuyerID, payload },
) {
  const url = `${appraisalService}/appraisal/deed/property/buyer/${deedBuyerID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const fetchDeeds = async (
  { appraisalService },
  authenticationToken,
  { pageSize, page, payload },
) => {
  const url = `${appraisalService}/appraisal/deeds/search?page=${page}&pageSize=${pageSize}&sortField=instrumentNum&sortDirection=desc`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export async function fetchLetterCodes(
  { appraisalService },
  authenticationToken,
  { deedID },
) {
  const url = `${appraisalService}/appraisal/deed/${deedID}/lettercodes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addLetterCode(
  { appraisalService },
  authenticationToken,
  { deedID, payload },
) {
  const url = `${appraisalService}/appraisal/deed/${deedID}/lettercodes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteLetterCode(
  { appraisalService },
  authenticationToken,
  { deedLetterCodeID },
) {
  const url = `${appraisalService}/appraisal/deed/lettercodes/${deedLetterCodeID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}
